import { motion } from 'framer-motion';
import { LuBookmark, LuLock, LuStar } from 'react-icons/lu';
import { ProgressBar } from '../../design-system/components';
import { formatPercent } from '../../utils/percent';
import type { PathWithProgress } from './types';

interface SidebarPathItemProps {
  path: PathWithProgress;
  isActive?: boolean;
  onClick: () => void;
}

/** A chapter row inside a sidebar unit (redesign PR4, course.css). */
export function SidebarPathItem({ path, isActive = false, onClick }: SidebarPathItemProps) {
  const progress = path.progress || 0;
  const score = path.average_score || 0;
  const state = path.locked ? 'locked' : isActive ? 'active' : 'idle';

  return (
    <motion.button
      type="button"
      onClick={onClick}
      disabled={path.locked}
      whileHover={!path.locked ? { x: 2 } : undefined}
      whileTap={!path.locked ? { scale: 0.98 } : undefined}
      className={`ee-side-path ee-side-path--${state}`}
    >
      {/* Icon */}
      <span
        className={`ee-side-path__icon ${path.mastered && !path.locked ? 'ee-side-path__icon--gold' : ''}`}
      >
        {path.locked ? (
          <LuLock aria-hidden="true" />
        ) : path.mastered ? (
          <LuStar aria-hidden="true" />
        ) : (
          <LuBookmark aria-hidden="true" />
        )}
      </span>

      {/* Title and Progress */}
      <span className="ee-side-path__info">
        <span className="ee-side-path__title">{path.title}</span>
        {!path.locked && (
          <span className="ee-side-path__progress">
            {/* Progress bar */}
            <ProgressBar value={progress} tone={path.mastered ? 'gold' : 'orange'} size="thin" />
            {/* Score */}
            {score > 0 && <span className="ee-side-path__score">{formatPercent(score)}</span>}
          </span>
        )}
      </span>
    </motion.button>
  );
}
